module.exports = __webpack_public_path__ + "static/media/4 Way Skew.c9764221.png";